import { ChainId, isTestEnv } from '@/constant';
import { getCurrentChainId } from '@/gql';
import config from '@/gql/config';
import { Client } from '@/gql/type';
import storage from '@/utils/storage';
import axios from 'axios';
import { getSelectAddress } from '.';

/**
 * Clear lazbubu data via GraphQL mutation
 * Returns true when backend responds with { data: { clearLazbubuData: "success" } }
 */
export async function clearLazbubuData(chainId?: ChainId): Promise<boolean> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cfg: any = config as any;
    const endpoint: string =
        cfg?.[chainId || getCurrentChainId()]?.[Client.graph];

    if (!endpoint) {
        throw new Error('Graph endpoint is not configured.');
    }

    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
    };
    if (isTestEnv) {
        const address = getSelectAddress();
        if (address) {
            headers.authorization = `Bearer ${address.toLowerCase()}`;
        }
    } else {
        const authData = storage.get('auth-token');
        if (authData && authData.token) {
            headers.authorization = `Bearer ${authData.token}`;
        }
    }

    const body = {
        operationName: 'Mutation',
        query: '\n\nmutation Mutation {\n  clearLazbubuData\n}',
        variables: {},
    };

    const res = await axios.post(endpoint, body, { headers });
    return res?.data?.data?.clearLazbubuData === 'success';
}
